module.exports = __webpack_public_path__ + "img/share.f7c250ac.svg";